<template>
	<div class="timecode">
		<div class="timecode__header">
			<h2 class="timecode__header-title">{{ $t('timecodes') }}</h2>
		</div>
		<div class="timecode__content">
			<ol class="timecode__list">
				<li v-for="chapter in chaptersData" class="timecode__item">
					<a class="timecode__link" @click="rewindTo(chapter)">
						<span class="timecode__descr" v-html="chapter.name"></span>
						<span class="timecode__time">{{chapter.time_human}}</span>
					</a>
				</li>
			</ol>
		</div>
	</div>
</template>

<script>
export default {
	name: "TimeCode",

	props: {
		chapters: Array,
	},

	data() {
		return {
			chaptersData: this.chapters,
			player: null,
			isAudio: false,
		};
	},

	mounted() {
		// Определяем, какой плеер использовать (видео или аудио)
		this.player = window.player || window.audioPlayer;
		this.isAudio = !!window.audioPlayer && !window.player;

		// Добавляем маркеры на таймлайн, если плеер доступен и есть плагин markers
		if (this.player && this.player.markers && this.chaptersData && this.chaptersData.length > 0) {
			try {
				this.player.markers({
					markers: this.chaptersData.map(chapter => ({
						time: chapter.time_in_sec,
						text: chapter.name
					}))
				});
			} catch (error) {
				console.warn('Failed to add markers to player:', error);
			}
		}
	},

	methods: {
		rewindTo: function(chapter) {
			// Получаем актуальную ссылку на плеер
			const player = window.player || window.audioPlayer;
			if (!player) {
				console.error('Player not found');
				return;
			}

			// Ищем заглушку (для видео или аудио)
			const stubSelector = this.isAudio ? '.j-hide-audio-stub' : '.j-hide-video-stub';
			const stub = document.querySelector(stubSelector);
			
			if (stub && !stub.classList.contains('not-showing')) {
				stub.classList.add('not-showing');
				setTimeout(() => {
					stub.classList.add("hide");
				}, 600);
			}

			// Перематываем на нужное время
			if (player.currentTime) {
				player.currentTime(chapter.time_in_sec);
			}
			
			// Запускаем воспроизведение
			if (player.play) {
				player.play();
			}
		},
	},
};
</script>
